export default "__VITE_ASSET__BuvTmMz2__"